<template>
  <HeaderDropdown right no-caret>
    <template slot="header">
      <i class="fa fa-wrench settings-icon" />
    </template>
    <template slot="dropdown">
      <b-dropdown-group id="drug-database" header="Drug Database">
        <b-dropdown-item @click="navigateToBrandNameDb" >By Brand Name</b-dropdown-item>
        <b-dropdown-item @click="navigateToNdcDb">By NDC</b-dropdown-item>
      </b-dropdown-group>
    </template>
  </HeaderDropdown>
</template>
<script>
import { HeaderDropdown } from '@coreui/vue';
import { router } from '@/router'
export default {
  name: 'DefaultSettingsDropdown',
  components: {
    HeaderDropdown
  },
  methods :{
    navigateToBrandNameDb(){
      router.push('/drugDatabase/brandname');
    },
    navigateToNdcDb(){
      router.push('/drugDatabase/ndc');
    }
  }
};
</script>
<style  scoped>
.settings-icon{
font-size: 1.5rem !important;  
}
</style>